'use client'

import { createContext, useContext } from 'react'

import { useSessionStore } from '@/features/veluvit/stores/session.store'
import { sessionAccessKey } from '@/features/veluvit/lib/app-read'

export const AppReadScopeContext = createContext<{
  epoch: string
  identity: number
  access?: string
} | null>(null)
export const AppRefreshContext = createContext<(() => void) | null>(null)

export function useAppReadScope(): string | null {
  const scope = useContext(AppReadScopeContext)
  const identity = useSessionStore((state) => state.identity)
  const access = useSessionStore((state) => sessionAccessKey(state.data))
  if (!scope) return null
  return identity === scope.identity &&
    (scope.access === undefined || access === scope.access)
    ? scope.epoch
    : `${scope.epoch}:${identity}:a${access}`
}
